import React from 'react'
import ReactModal from 'react-modal'

import { asideInlineStyles, defaultInlineStyles } from './constants'
import * as S from './styles'

import './styles.scss'

import type { ModalProps } from './types'

ReactModal.setAppElement(document.getElementById('root'))

/**
 * Modal component based on {@link https://github.com/reactjs/react-modal react-modal}
 * @component
 * @param {boolean} slideAside - modal slides from left the side when open
 * @param {string} title - modal header title
 * @param {function} onClose - onClose handler (onRequestClose prop in react-modal)
 */
export const Modal = ({
  children,
  title,
  onClose = () => {
    // No-op function for default close handler
  },
  style,
  slideAside = false,
  leftHeader = false,
  withCrossButton = true,
  isScrollable = false,
  ...restProps
}: ModalProps) => {
  const bodyOpenClassNames = `ReactModal__Body--open ${slideAside ? 'ReactModal--aside' : 'ReactModal--float'}`

  const isHeaderVisible = !!title || withCrossButton

  const defaultStyle = slideAside ? asideInlineStyles : defaultInlineStyles
  return (
    <ReactModal
      onRequestClose={onClose}
      preventScroll
      parentSelector={() => document.getElementById('root')}
      closeTimeoutMS={300}
      style={style || defaultStyle}
      portalClassName={bodyOpenClassNames}
      {...restProps}
    >
      <S.ModalContent $isScrollable={isScrollable}>
        {isHeaderVisible && (
          <S.ModalHeader
            slideAside={slideAside}
            leftHeader={leftHeader}
            $isScrollable={isScrollable}
          >
            {title}
            {withCrossButton && (
              <>
                {' '}
                <S.CloseButton
                  slideAside={slideAside}
                  leftHeader={leftHeader}
                  type="button"
                  onClick={onClose}
                  aria-label="close"
                />
              </>
            )}
          </S.ModalHeader>
        )}
        <S.ModalContainer
          slideAside={slideAside}
          leftHeader={leftHeader}
          $isScrollable={isScrollable}
        >
          {children}
        </S.ModalContainer>
      </S.ModalContent>
    </ReactModal>
  )
}
